import { createActionGroup, emptyProps } from '@ngrx/store';

export const actions = createActionGroup({
    source: 'ui',
    events: {
        'Show Menu': emptyProps(),
        'Hide Menu': emptyProps(),
    },
});
